const FEATURE_LIMIT_MESSAGES = {
  conversations:
    "Your monthly conversation limit is reached. Please upgrade your plan before sending more messages.",
  templateSends:
    "Your monthly template send limit is reached. Please upgrade your plan.",
  bulkMessageSends:
    "Your monthly bulk message send limit is reached. Please upgrade your plan.",
  sessionHistory:
    "Your monthly session history limit is reached. You cannot close conversations until you upgrade your plan.",
  contacts:
    "Your monthly contact limit is reached. Please upgrade your plan before adding more contacts.",
};

/**
 * Resolve user-facing text from a limit API error body or thrown payload.
 * @param {object|string|null} errBody
 * @returns {string}
 */
export function getUsageLimitMessage(errBody) {
  if (!errBody) {
    return "Your monthly limit is exceeded. Please upgrade your plan.";
  }
  if (typeof errBody === "string") {
    return errBody;
  }
  if (errBody.message) {
    return errBody.message;
  }
  if (errBody.featureKey && FEATURE_LIMIT_MESSAGES[errBody.featureKey]) {
    return FEATURE_LIMIT_MESSAGES[errBody.featureKey];
  }
  if (errBody.code === "LIMIT_EXCEEDED") {
    return "Your monthly limit is exceeded. Please upgrade your plan.";
  }
  return errBody.error || "Something went wrong. Please try again.";
}

export { FEATURE_LIMIT_MESSAGES };
